import {Component, ViewChild, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataTableComponent, ColHeaderTypeEnum, LocalDataTableDataSource} from 'mars-modules';
import {AUDIT_COLUMNS, AUDIT_COLUMNS_AS_ARRAY} from './asset-audit-table-settings';
import {AssetAudit} from '../../shared/domain/item';
import {ItemSummaryAssetAuditService} from '../../shared/asset/audit/item-summary-asset-audit.service';
import {ItemSummaryAssetAuditImplService} from '../../shared/asset/audit/item-summary-asset-audit-impl.service';

@Component({
  selector: 'lib-item-summary-asset-audit',
  templateUrl: './asset-audit.component.html',
  styleUrls: ['./asset-audit.component.scss'],
  providers: [
    {provide: ItemSummaryAssetAuditService, useClass: ItemSummaryAssetAuditImplService}
  ]
})
export class AssetAuditComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  readonly columns = AUDIT_COLUMNS;
  readonly ColHeaderTypeEnum = ColHeaderTypeEnum;
  readonly pageSizeOptions = [25, 50, 100];
  readonly columnsToShow: string[];
  readonly pageSize = 25;

  dataSource: LocalDataTableDataSource<AssetAudit>;
  assetInformationList: AssetAudit[] = [];
  keywords: string;
  isLoadingInformation: boolean;

  modalTitle: string;
  assetId: number;

  constructor(private dialogRef: MatDialogRef<AssetAuditComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any,
              private assetAuditService: ItemSummaryAssetAuditService) {
    this.isLoadingInformation = true;
    this.dataSource = new LocalDataTableDataSource<AssetAudit>(AUDIT_COLUMNS_AS_ARRAY);
    this.columnsToShow = AUDIT_COLUMNS_AS_ARRAY.map(col => col.field);
    this.modalTitle = dialogData.modalTitle;
    this.assetId = dialogData.assetId;
  }

  close() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
    this.loadAssetAuditInformation();
  }

  private loadAssetAuditInformation() {
    this.assetAuditService.getAssetAuditInformation(this.assetId).subscribe(response => {
      this.assetInformationList = response;
      this.dataSource.setData(this.assetInformationList);
      this.isLoadingInformation = false;
    });
  }

  filterResults() {
    if ( this.keywords ) {
      const filterList: AssetAudit[] = this.assetInformationList.filter(auditItem => this.includesResult(auditItem) );
      this.dataSource.setData(filterList);
    } else {
      this.dataSource.setData(this.assetInformationList);
    }
  }

  includesResult(auditItem: AssetAudit ): boolean {
    const auditType: string = (auditItem.auditType) ? auditItem.auditType.toLowerCase() : '';
    const oldValue: string = (auditItem.oldValue) ? auditItem.oldValue.toLowerCase() : '';
    const newValue: string = (auditItem.newValue) ? auditItem.newValue.toLowerCase() : '';
    const adminUserLogin: string = (auditItem.adminUserLogin) ? auditItem.adminUserLogin.toLowerCase() : '';
    const createdDate: string = (auditItem.createdDate) ? auditItem.createdDate.toLocaleString().toLowerCase() : '';
    const keyword: string = this.keywords.toLowerCase();

    return auditType.includes(keyword)
      || oldValue.includes(keyword)
      || newValue.includes(keyword)
      || adminUserLogin.includes(keyword)
      || createdDate.toLocaleString().includes(keyword);
  }

  clearFilter() {
    this.keywords = '';
    this.filterResults();
  }

}
